/*
 * @Description: 报告自动化布局
 * @Author: yy
 * @Date: 2019-05-31 14:47:31
 * @LastEditors: yy
 * @LastEditTime: 2021-02-19 11:30:04
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// @ts-ignore
import s from './ExportLayout.css';
import ExportLogo from '../ExportLogo/ExportLogo'
import Link from '../Link/Link';
import { getSessionQuery, convertCanvasToImage, saveFile } from '../../utils';
// import html2canvas from 'html2canvas'

const linksMap = {
  SetPage: '查询条件',
  P2: '报告摘要',
  P5: '一周数字品牌价值走势',
  P6: '用户参与度',
  P7: '一周口碑舆情分析',
  P8: '一周用户情感倾向趋势',
  P9: '微信平台数字品牌价值及三维度',
  P12: '平台本周官方KOL',
  P22: '心智占有率-行业表现与对比',
  P23: '心智占有率 – 重点竞品对比',
  P24: '数字品牌价值 – 重点竞品对比',
  P25: '用户口碑三维度 - 重点竞品对比',
  P26: '用户参与及好感 – 重点竞品对比',
  P27: '竞品数字品牌价值',
  P30: '行业排行',
  pageNull: '没有当前页面'
}

class ExportLayout extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      brandId: 1,
      links: this.props.links || [],
    }

    this.screen = null

    this.capture = this.capture.bind(this)
  }

  componentDidMount () {
    this.setBrandId();
    this.getSomeData();
  }

  getQuery () {
    const query = getSessionQuery('query');

    return {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
  }

  getSomeData () {
    const somedata = getSessionQuery('somedata')
    this.getBrandId(somedata.brandId);
  }

  setBrandId () {
    const that = this;
    try {
      Object.defineProperty(global, 'brandId', {
        set (val) {
          that.getBrandId(val)
        }
      })
    } catch (err) {}
  }

  getBrandId (id) {
    this.setState({
      brandId: id
    });
  }

  /**
   * 截图并下载
   */
  capture () {
    const html2canvas = require('html2canvas')

    const query = this.getQuery()
    
    html2canvas(this.screen, {
      scale: 2
    })
      .then(canvas => {
        const src = convertCanvasToImage(canvas).src
        console.log(src)
        saveFile(src, `报告自动化-${query.brandName}-${location.pathname.split('').pop()}`)
      })
  }

  render () {
    const links = this.state.links;

    return (
      <div className={s.container}>
        <h1 className={s.pageTitle}>
          <span>{`报告自动化`}</span>
          <small>1280/720； 30px/20px 微软雅黑</small>
        </h1>

        <div className={s.toolView}>
          <div className={s.pageWrapper}>
            {links.map(item => <Link to={`/exportPDF/${item}`} key={item}>{`${item}:${linksMap[item]}`}</Link>)}
          </div>
        </div>
        <div className={s.pageView} ref={ele => this.screen = ele}>
          <ExportLogo brandId={this.state.brandId}></ExportLogo>
          {this.props.children}
          <div className={s.capture} onClick={this.capture}>截图</div>
          
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ExportLayout);


// WEBPACK FOOTER //
// src/components/ExportLayout/ExportLayout.js